const subUsersES = {
    "view": {
        "table": {
            "title": "Tu lista de sub-usuarios",
            "column": {
                "username": "Nombre de usuario",
                "email": "Correo electrónico",
                "first_name": "Nombre",
                "last_name": "Apellido",
                "company": "Empresa",
                "sub_user_deal": "Acuerdo (%)",
                "contract_expiry": "Vencimiento del contrato",
                "is_active": "Activo",
                "action": "Acción"
            },
            "button": {
                "edit": "Editar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "label": {
                "yes": "Sí",
                "no": "No"
            },
            "dropdown": {
                "action": "Acción",
                "edit": "Editar",
                "activate": "Activar",
                "deactivate": "Desactivar"
            }
        },
        "message": {
            "successUpdated": "¡La cuenta del sub-usuario ha sido actualizada!",
            "successActivated": "¡La cuenta del sub-usuario ha sido activada!",
            "successDeactivated": "¡La cuenta del sub-usuario ha sido desactivada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "premiumUsersOnly": "Esta función se ofrece solo a Usuarios Premium. Por favor, contacta al equipo de soporte si deseas actualizar tu cuenta.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        },
        "modal": {
            "activateSubuser": {
                "header": "Activar Sub-usuario",
                "body": "¿Estás seguro de que deseas activar al sub-usuario {{username}}?"
            },
            "deactivateSubuser": {
                "header": "Desactivar Sub-usuario",
                "body": "¿Estás seguro de que deseas desactivar al sub-usuario {{username}}?"
            },
            "button": {
                "cancel": "Cancelar",
                "edit": "Editar",
                "activate": "Activar",
                "deactivate": "Desactivar"
            }
        }
    },
    "add": {
        "title": "Agregar Sub-usuario",
        "form": {
            "label": {
                "personalDetails": "Detalles Personales",
                "firstName": "Nombre",
                "lastName": "Apellido",
                "email": "Correo electrónico",
                "username": "Nombre de usuario",
                "password": "Contraseña",
                "confirmPassword": "Confirmar Contraseña",
                "businessDetails": "Detalles del Negocio",
                "companyName": "Nombre de la Empresa",
                "contractExpiry": "Vencimiento del contrato",
                "subUserDeal": "Acuerdo del Sub-usuario (%)",
                "nationalTaxNumber": "Número de Impuesto Nacional",
                "businessRegistrationNumber": "Número de Registro de Empresa",
                "contactDetails": "Detalles de Contacto",
                "streetAndNumber": "Calle y número de casa",
                "postalCode": "Código Postal",
                "city": "Ciudad",
                "country": "País",
                "phoneNumber": "Número de Teléfono"
            },
            "help_text": {
                "contractExpiry": "Nota: La fecha de vencimiento del contrato no puede establecerse antes de {{afterOneYear}}."
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "¡El sub-usuario ha sido agregado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        },
        "modal": {
            "header": "Agregar Sub-usuario",
            "body": "¿Estás seguro de que deseas crear un nuevo sub-usuario?"
        }
    },
    "update": {
        "title": "Editar Sub-usuario",
        "form": {
            "label": {
                "personalDetails": "Detalles Personales",
                "firstName": "Nombre",
                "lastName": "Apellido",
                "email": "Correo electrónico",
                "username": "Nombre de usuario",
                "password": "Contraseña",
                "confirmPassword": "Confirmar Contraseña",
                "businessDetails": "Detalles del Negocio",
                "companyName": "Nombre de la Empresa",
                "contractExpiry": "Vencimiento del contrato",
                "subUserDeal": "Acuerdo del Sub-usuario (%)",
                "nationalTaxNumber": "Número de Impuesto Nacional",
                "businessRegistrationNumber": "Número de Registro de Empresa",
                "contactDetails": "Detalles de Contacto",
                "streetAndNumber": "Calle y número de casa",
                "postalCode": "Código Postal",
                "city": "Ciudad",
                "country": "País",
                "phoneNumber": "Número de Teléfono"
            },
            "help_text": {
                "contractExpiry": "Nota: La fecha de vencimiento del contrato no puede establecerse antes de {{afterOneYear}}."
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "¡El sub-usuario ha sido actualizado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        }
    }
};

export default subUsersES;